import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: "success-view",
  class: "success-view"
}
const _hoisted_2 = {
  key: 0,
  class: "success-view__container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-label": "close modal"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "success-view__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-checkmark success-view__title-check",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "success-view__list" }
const _hoisted_11 = { class: "success-view__list-item success-view__list-item-label" }
const _hoisted_12 = { class: "success-view__list-item-title" }
const _hoisted_13 = { class: "success-view__list-item-value" }
const _hoisted_14 = { class: "success-view__list-item" }
const _hoisted_15 = { class: "success-view__list-item-title" }
const _hoisted_16 = { class: "success-view__list-item-value" }
const _hoisted_17 = { class: "success-view__list-price" }
const _hoisted_18 = { class: "success-view__list-price-title" }
const _hoisted_19 = { class: "success-view__list-price-value" }
const _hoisted_20 = { class: "success-view__button-wrapper" }
const _hoisted_21 = { class: "row g-3 justify-content-center" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 1,
  class: "success-view__container"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close",
  "aria-label": "close modal"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.successData.success)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn success-view__close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCloseModal && _ctx.onCloseModal(...args)))
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.ticket.configuration.success-view-title')), 1)
          ]),
          (_ctx.successData.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.successData.errorMessage), 1))
            : _createCommentVNode("", true),
          (_ctx.successData.template)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                innerHTML: _ctx.successData.template
              }, null, 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.translate('shop.ticket.configuration.ticket')), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.translate('shop.ticket.configuration.price')), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketConfigurations, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.selectedTicketName ? _ctx.selectedTicketName : _ctx.title) + " | " + _toDisplayString(item.priceGroupName?.singularName) + " ", 1),
                        _createElementVNode("span", null, _toDisplayString(item.serviceName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, " CHF " + _toDisplayString(item.priceSum.toFixed(2)), 1)
                    ]))
                  }), 256)),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate('shop.ticket.configuration.total')), 1),
                    _createElementVNode("span", _hoisted_19, " CHF " + _toDisplayString(_ctx.total().toFixed(2)), 1)
                  ])
                ])
              ])),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("a", {
                  href: _ctx.continueUrl,
                  class: _normalizeClass(["btn btn-outline-secondary w-100", !_ctx.isMobile ? 'btn-sm' : ''])
                }, _toDisplayString(_ctx.translate('shop.ticket.configuration.continue-shopping')), 11, _hoisted_23)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", {
                  href: _ctx.cartUrl,
                  class: _normalizeClass(["btn btn-outline-secondary w-100", !_ctx.isMobile ? 'btn-sm' : ''])
                }, _toDisplayString(_ctx.translate('shop.ticket.configuration.go-to-cart')), 11, _hoisted_25)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("a", {
                  href: _ctx.checkoutUrl,
                  class: _normalizeClass(["btn btn-primary w-100", !_ctx.isMobile ? 'btn-sm': ''])
                }, _toDisplayString(_ctx.translate('shop.ticket.configuration.go-to-checkout')), 11, _hoisted_27)
              ])
            ])
          ])
        ]))
      : (Object.keys(_ctx.successData).length > 0 && !_ctx.successData.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "btn success-view__close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCloseModal && _ctx.onCloseModal(...args)))
            }, _hoisted_30),
            _createVNode(_component_Error, {
              errorMessage: _ctx.successData.errorMessage
            }, null, 8, ["errorMessage"])
          ]))
        : _createCommentVNode("", true)
  ]))
}